define(function (require, exports, module) {
    'use strict';

    var config = require('Cloud/config');

    var PAGE_ID = config.get('x-page-id');
    var i = 0;

    /**
     * @returns {string}
     */
    function uid() {
        return PAGE_ID + '-' + Date.now().toString(36) + '-' + i++;
    }

    module.exports = uid;
});
